import React from 'react';
import { Helmet } from 'react-helmet-async';
import LayOut from './LayOut';

const GalleryGrid: React.FC = () => {
  return (
    <div>
      <Helmet>
        <title>DPR Gallery, News, Media, Achievements, Rewards, etc</title>
        <meta name="description" content="Explore our gallery, latest news, media highlights, achievements, and awards showcasing our expertise and offerings" />
        <meta name="keywords" content="hyderabad real estate, real estate companies in hyderabad, real estate firms in hyderabad, best real estate company in hyderabad" />
      </Helmet>
      <LayOut />
    </div>
  );
};

export default GalleryGrid;